import { PureComponent, ReactNode } from 'react'
import { Steps } from 'antd';
import { withRouter, RouteComponentProps } from "react-router-dom";
import { connect } from 'react-redux';
import { stepperMoving, viewAccountTable } from '../stores/actions';

const { Step } = Steps;

interface StepConfig {
    title: ReactNode;
    content: ReactNode;
    id: number;
}

interface Props extends RouteComponentProps<any> {
    componentSteps?: StepConfig[],
    stepNumber?: number,
    stepperMoving: (step: number) => void;
    request?: boolean,
    viewAccountTable(value: boolean): void,
}

export class Stepper extends PureComponent<Props> {
    componentDidUpdate(prevProps: Props) {
        if (this.props.stepNumber !== prevProps.stepNumber) {
            this.clearHistoryParams(-1)
        }
        if (prevProps.stepNumber === -1) {
            this.props.stepperMoving(0);
        }
    }

    clearHistoryParams = (step: number) => {
        const match = this.props.match
        if (match.params.id && this.props.stepNumber === 0) {
            this.props.history.push(match.url.slice(0, match.url.indexOf(match.params.id) - 1))
            this.props.stepperMoving(step);
            this.props.viewAccountTable(false)
        }
    }

    onStepperChange = (step: number) => {
        this.clearHistoryParams(step)
        if (this.props.stepNumber && this.props.stepNumber !== 0 && step < this.props.stepNumber) {
            this.props.stepperMoving(step);
            this.props.viewAccountTable(false)
        }
    }

    render() {
        const { componentSteps, stepNumber } = this.props;
        const steps = componentSteps ?? [];
        if (!steps.length) return null;

        const activeStep = typeof stepNumber === 'number' ? stepNumber : 0;
        const activeContent = steps.find((step) => step.id === activeStep);

        return (
            <div className="ops-stepper">
                <div className="ops-stepper__track">
                    <Steps current={stepNumber} onChange={this.onStepperChange}>
                        {steps.map((step, idx) => (
                            <Step
                                key={idx}
                                title={step.title}
                                disabled={activeStep >= 0 && step.id > activeStep}
                            />
                        ))}
                    </Steps>
                </div>
                {activeContent && (
                    <div className="ops-stepper__body" key={activeContent.id}>
                        {activeContent.content}
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state: any) => ({
    stepNumber: state.actionsReducer.stepNumber,
})
export default withRouter(connect(mapStateToProps, { stepperMoving, viewAccountTable })(Stepper))
